import { conditionalItems } from './object.mjs';

export default function localeMethods(nuxtApp) {
    const { locales: localeConfig = [] } = nuxtApp.$i18n;

    const localeObject = {
        code: localeConfig?.value?.find(locale => locale.code === nuxtApp.$i18n?.locale.value).code ?? null,
        domain: localeConfig?.value?.find(locale => locale.code === nuxtApp.$i18n?.locale.value)?.domain ?? null,
        lang: localeConfig?.value?.find(locale => locale.code === nuxtApp.$i18n?.locale.value)?.code.split('-')[0] ?? null,
        country: localeConfig?.value?.find(locale => locale.code === nuxtApp.$i18n?.locale.value)?.code.split('-')[1] ?? null,
        accountHubUrl: localeConfig?.value?.find(locale => locale.code === nuxtApp.$i18n?.locale.value)?.accountHubUrl ?? null,
        /**
         *
         * @param {boolean} include inclusion flag
         * @param {*} data locales + optional object element
         * @returns {boolean | array} Boolean if no optional element passed, otherwise an array
         *
         */
        manage: (include, data) => {
            let locales;
            let element;
            const lastArg = data[data.length - 1];

            if (typeof lastArg !== 'string') {
                element = data.pop();
                locales = data;

                const condition = locales.includes(nuxtApp.$i18n.locale.value);

                return include
                    ? conditionalItems(condition, [ element ])
                    : conditionalItems(!condition, [ element ]);
            }

            locales = data;

            return include
                ? locales.includes(nuxtApp.$i18n.locale.value)
                : !locales.includes(nuxtApp.$i18n.locale.value);
        },
        /**
         *
         * @param  {...any} data included locales as string arguments + optional object element
         * @returns {boolean | array }
         *
         * @example
         * // returns {a: 1, b: 2} for Finnish, Swedish and English locales
         * dsc.locale.include('fi', 'se', 'en', {a: 1, b: 2});
         */
        include: (...data) => localeObject.manage(true, data),
        /**
         *
         * @param  {...any} data included locales as string arguments + optional object element
         * @returns {boolean | array }
         *
         * @example
         * // returns {a: 1, b: 2} for all locales, except Swedish
         * dsc.locale.exclude('se', {a: 1, b: 2});
         */
        exclude: (...data) => localeObject.manage(false, data),
        countryToCountryCode(country) {
            const mapping = {
                fi: 'FI',
                fin: 'FI',
                finland: 'FI',
                suomi: 'FI',
                svfi: 'FI',
                se: 'SE',
                swe: 'SE',
                sweden: 'SE',
                sverige: 'SE',
                no: 'NO',
                norway: 'NO',
                norge: 'NO',
            };

            return mapping[country.toLowerCase()];
        },
        mapLocale(locale = nuxtApp.$i18n.locale.value) {
            const customLocales = {
                svfi: 'sv',
                se: 'sv',
                no: 'nb',
            };

            return (customLocales[locale] || locale).toLowerCase();
        },
        localizedCountries: (locale = nuxtApp.$i18n.locale.value) => require(`localized-countries/data/${locale}`),
        countryByCode: (code, locale = nuxtApp.$i18n.locale.value) => localeObject.localizedCountries(localeObject.mapLocale(locale))[code],
        countryList: ({ withCode = true, locale = nuxtApp.$i18n.locale.value }) => {
            const countries = localeObject.localizedCountries(localeObject.mapLocale(locale));
            const currentCountryCode = localeObject.countryToCountryCode(nuxtApp.$i18n?.locale.value);
            const name = countryCode => withCode ? `${countries[countryCode]} - ${countryCode}` : countries[countryCode];

            const primaryCountries = [
                ...currentCountryCode !== 'NO' ? ['NO'] : [],
                ...currentCountryCode !== 'SE' ? ['SE'] : [],
                ...currentCountryCode !== 'FI' ? ['FI'] : [],
            ];

            const countryList = Object.keys(countries).reduce((acc, countryCode) => {
                const countryInfo = {
                    name: name(countryCode),
                    value: countryCode,
                };

                if (primaryCountries.includes(currentCountryCode)) return acc;

                primaryCountries.includes(countryCode)
                    ? acc.unshift(countryInfo)
                    : acc.push(countryInfo);

                return acc;
            }, []);

            countryList.unshift({
                name: name(currentCountryCode),
                value: currentCountryCode,
            });

            return countryList;
        },
    };

    localeConfig?.value?.forEach(locale => localeObject[locale.code] = nuxtApp.$i18n?.locale.value === locale.code);

    return localeObject;
}
